// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"97ab6641","107":"8fe09372","303":"7c2aaadb","357":"9ab702d7","590":"9d333a4c","634":"bc0a2b46","687":"28d844bf","748":"9280eb67","752":"d338fb5b"}[chunkId] + ".chunk.js";
};